import { useCallback, useRef } from "react";
import { logPodcastAction } from "../helpers/AnalyticsTags";

const MEDIA_ERRORS = { 1: "aborted", 2: "network", 3: "decode", 4: "not_supported" };

export default function useInteractiveMapDiagnostics(context) {
  const contextRef = useRef(context);
  const mediaKeysRef = useRef(new Set());
  contextRef.current = context;

  const logRoutePlaybackDiagnostic = useCallback((action, cta = "", nodeId) => {
    const current = contextRef.current;
    const node = nodeId === undefined ? current.nearestNodeIdRef.current : nodeId;
    logPodcastAction({
      platform: current.isMobile ? "mobile" : "web",
      action,
      cta: String(cta || ""),
      node: String(node || ""),
      chapter: `${String(node || "")}_${current.selectedLanguage}`,
      param_lang: current.selectedLanguage,
      podcast: current.selectedSimulation?.name || String(current.podcastId || ""),
    });
  }, []);

  const logRouteMediaDiagnostic = useCallback((action, media) => {
    const source = String(media?.currentSrc || media?.src || "");
    if (!source) return;
    const detail = action === "interactive_map_media_error"
      ? MEDIA_ERRORS[media?.error?.code] || "unknown"
      : action === "interactive_map_media_can_play" ? "ready" : "started";
    const mediaType = String(media?.tagName || contextRef.current.routesMediaKind || "media").toLowerCase();
    const key = `${source}|${action}|${detail}`;
    if (mediaKeysRef.current.has(key)) return;
    mediaKeysRef.current.add(key);
    logRoutePlaybackDiagnostic(action, `${mediaType}:${detail}`);
  }, [logRoutePlaybackDiagnostic]);

  const resetMediaDiagnostics = useCallback(() => mediaKeysRef.current.clear(), []);

  return { logRoutePlaybackDiagnostic, logRouteMediaDiagnostic, resetMediaDiagnostics };
}
